import { c as _c } from "react/compiler-runtime";
import TypeRating from './TypeRating';
const RatingsByType = t0 => {
    const $ = _c(4);
    const { byType } = t0;
    let t1;
    if ($[0] !== byType) {
        t1 = byType.map(_temp);
        $[0] = byType;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
        t2 = <table><tbody>{t1}</tbody></table>;
        $[2] = t1;
        $[3] = t2;
    }
    else {
        t2 = $[3];
    }
    return t2;
};
export default RatingsByType;
function _temp(rating) {
    return <TypeRating key={rating.criteria.type} {...rating}/>;
}
